import { createUseStyles } from 'react-jss';

import { ITheme } from '../../../../../styles';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      listStyleType: 'none',
      gap: 8,
    },
    text: {
      color: 'var(--x-text-color-4)',
      fontSize: 14,
      fontWeight: 600,
      lineHeight: '32px',
    },
  }),
  { name: 'BottomLinks' },
);

export default useStyles;
